<template>
  <p v-if="deadLineDateText" :class="['m-0 p-0 text-lowercase small', { 'text-danger': !isAfter }]">{{$t('views.excmcase.show.deadline')}} {{deadLineDateText}}</p>
</template>
<script>
import moment from 'moment'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'deadlineDateInfo',
  props: {
    item: {}
  },
  computed: {
    isAfter () {
      if (this.item.deadlineDate) {
        return moment(this.item.deadlineDate).isAfter(moment())
      }
      return false
    },
    deadLineDateText () {
      if (this.item.deadlineDate) {
        if ((this.item['@type'] === 'EXCMCase' && getId(this.item.status['@id']) === '2') || (this.item['@type'] === 'EXCMTask' && this.item.finished)) {
          return ''
        }
        let deadlineDate = moment(this.item.deadlineDate)
        if (this.isAfter) {
          return deadlineDate.fromNow()
        } else {
          return deadlineDate.fromNow()
        }
      }
      return ''
    }
  }
}
</script>
